import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {Category, SalesWorkflow} from "projects/store/src/app/enums";


@Component({
  selector: 'app-sales-credit-summary',
  templateUrl: './sales-credit-summary.component.html'
})
export class SalesCreditSummaryComponent implements OnInit {
  requestId: string;
  flowCode: string;
  request: any
  categoryCode: string;
  isTopUpLoan: boolean = false;
  isExpressFlow: boolean = false;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();

  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private router: Router,
              private utilService: UtilService,
              private customMessageService: CustomMessageService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.categoryCode = this.route.snapshot.params['category_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.isTopUpLoan = this.request?.top_up_loan ?? false;
    this.isExpressFlow = this.flowCode === SalesWorkflow['kredicash-express'];
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onGotoStep(navigationData: { flowCode: string; stepCode: string }) {
    this.gotoStepEvent.emit(navigationData);
  }

  protected readonly Category = Category;
}
